import * as React from "react";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { Button, Divider, Grid, Menu, Segment } from "semantic-ui-react";
import { Detail as SimpleDetail } from "@neworbit/simpleui-detail";

import { Action } from "redux";

import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { ApplicationState } from "../../../applicationState";

import { CustomerCategoryDetailModel } from "../model";
import { customerCategorySelector, basePathSelector, routeIdSelector } from "../selectors";

import { loadCustomerCategoryDetail } from "../actions";

import { DeleteButton } from "./DeleteButton";

import { Link, push } from "redux-little-router";

export interface CoreDetailProps {
    customerCategory: CustomerCategoryDetailModel;
}

export interface DetailProps extends CoreDetailProps {
    path: string;
    basePath: string;
    tab?: string;
}

export interface DispatchProps {
    push: (path: string) => void;
}

const DetailUnconnected: React.FunctionComponent<DetailProps & DispatchProps> = (props) => {
    const dispatch = useDispatch();
    const customerCategoryId = useSelector(routeIdSelector);

    React.useEffect(() => {
        dispatch(loadCustomerCategoryDetail({ customerCategoryId }));
    }, [customerCategoryId, dispatch]);

    return (
        <Grid container className="nomargintop">
            <Grid.Row>
                <Grid.Column>
                    <h1>{props.customerCategory.name}</h1>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={3} as={Grid} padded>
                    <Grid.Column vertical as={Menu}>
                        <Menu.Item name="CustomerCategories" as={Link} href={props.basePath}>
                            All Customer Categories
                        </Menu.Item>
                    </Grid.Column>
                </Grid.Column>

                <Grid.Column width={13}>
                    <Grid>
                        <SimpleDetail label="Name" value={props.customerCategory.name} labelWidth={5} valueWidth={11} />
                    </Grid>
                    <Divider />
                    <Segment basic clearing vertical>
                        <DeleteButton />
                        <Button icon="pencil" content="Edit" floated="right" as={Link} href={`${props.path}/edit`} />
                    </Segment>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};

function mapStateToProps(state: ApplicationState): DetailProps {
    return {
        customerCategory: customerCategorySelector(state),
        path: state.router.pathname,
        basePath: basePathSelector(state)
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<ApplicationState, undefined, Action>): DispatchProps {
    return {
        push: (path: string) => dispatch(push(path, {}))
    };
}

export const Detail = connect(mapStateToProps, mapDispatchToProps)(DetailUnconnected);
